import script from "./desktop.vue?vue&type=script&setup=true&lang=ts"
export * from "./desktop.vue?vue&type=script&setup=true&lang=ts"

import "./desktop.vue?vue&type=style&index=0&id=3932a962&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3932a962"]])

export default __exports__